// src/config/firebaseConfig.js
const firebaseConfig = {
    apiKey: "AIzaSyDfPlzhVzjlY1akoORQNtHE5xVRqO8KWcY",
    authDomain: "wappsync-web.firebaseapp.com",
    projectId: "wappsync-web",
    storageBucket: "wappsync-web.firebasestorage.app",
    messagingSenderId: "855196554946",
    appId: "1:855196554946:web:391574ca17cd5d517f8d5b",
    measurementId: "G-WXW8ETXB40"
};

export default firebaseConfig;